const ServiceProvider = {

    // FIELDS
    "premise": "Premise",
    "name": "Name",
    "mobile": "Mobile Number",
    "type": "Type",
    "sub_type": "Sub Type",
    "id_type": "ID Type",
    "id_number": "ID Number",
    "upload_document": "Upload Document",
    "validity": "Validity",
    "profile": "Upload Profile",
    "present_address": "Present Address",
    "same_as_present": "Same as Present Address",
    "permanent_address": "Permanent Address",
    "police_verification": "Police Verification",
    "is_hireable": "Is Hireable",
    "is_frequent_visitor": "Is Frequent Visitor",
    "unit_details": "Unit Details",
    "units": "Units",
    "other_details": "Other Details",
    "document": "Document",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "serviceProvider": "Service Provider",
    "validUntil": "Valid Until",
    "registered": "Registered",
    "personalInfo": "Personal Information",
    "serviceInfo": "Service Information",
    "verification": "Verification & Flags",
    "document": "Document",

    // ERROR
    "error_premise": "Select Premise",
    "error_name": "Enter Name",
    "error_mobile": "Enter Mobile Number",
    "error_invalid_mobile": "Enter Valid Mobile Number",
    "error_type": "Select Type",
    "error_sub_type": "Select Sub Type",
    "error_validity": "Select Validity Date",
    "error_status": "Select Status",
    "error_id_type": "Select ID Type",
    "error_id_number": "Enter ID Number",
    "error_present_address": "Enter Present Address",
    "error_permanent_address": "Enter Permanent Address",
    "error_police_verification": "Select Police Verification",
    "error_is_hireable": "Select Hireable",
    "error_is_frequent": "Select Frequent Visitor",

    // TABLE HEADER
    "table_premise": 'PREMISE',
    "table_name": 'NAME',
    "table_mobile": 'MOBILE',
    "table_type": 'TYPE',
    "table_sub_type": 'SUB TYPE',
    "table_validity": 'VALIDITY',
    "table_status": 'STATUS',

    // RADIO BUTTON OPTIONS
    "verified": "Verified",
    "not_verified": "Not Verified",
    "hireable": "Hireable",
    "not_hireable": "Not Hireable",
    "frequent": "Frequent Visitor",
    "not_frequent": "Non Frequent Visitor",

}

export default ServiceProvider;